export default __webpack_public_path__ + "static/media/6.d39e3789.png";